import axios from "axios";

export const sendEmail = async (firstname, lastname, linkedin, email) => {
  return axios.post(
    `https://lnkdnsrvc785.eastus2.cloudapp.azure.com/scheduleDemoEmail?firstName=${firstname}&lastName=${lastname}&linkedin=${linkedin}&email=${email}`
  );
};

/**
 * Send Email Message
 * @param {String} email The email address
 * @param {String} subject The subject of the message
 * @param {String} message The message of the email
 * @returns void
 */
export const financialAccess = async (email, subject, message) => {
  return axios.post(
    "https://lnkdnsrvc785.eastus2.cloudapp.azure.com/sendEmailBySubject",
    {
      email: "contact@n5now.com",
      subject,
      message: `
      Email: ${email},
      <br>
      Message: ${message}
      `,
    }
  );
};

export const digitalAmerica = async ({ name, email, linkedin }) => {
  return axios.post(
    "https://lnkdnsrvc785.eastus2.cloudapp.azure.com/sendEmailBySubject",
    {
      email: "contact@n5now.com",
      subject: "Inscripcion America Digital",
      message: `
      Name: ${name}
      <br/>
      Email: ${email}
      <br>
      Linkedin: ${linkedin}
      `,
    }
  );
};
